import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import EditPanel from './EditPanel';
import OfferPreview from '../../../components/OfferPreview';

@observer
export default class SaleEditSection extends Component {
  @observable page = 1;

  handleSaveValues = async (data) => {
    const { store } = this.props;
    await store.update(data);
  };

  handleUpload = async (file) => {
    const { store } = this.props;
    return await store.upload(file);
  };

  handleDelete = async (file) => {
    const { store } = this.props;
    return await store.remove(file);
  };

  handleSaveDocs = async (data) => {
    const { store } = this.props;
    await store.updateDocs(data);
  };

  handleCancel = () => {
    this.props.ui.closePanel();
  };

  render() {
    const {
      ui,
      store: { offerData, docs, root },
    } = this.props;
    const { isStarted, isOpen } = root.round;

    return (
      <div>
        {ui.currentPanel === 'saleEdit' && (
          <EditPanel
            isRoundStarted={isStarted || isOpen}
            offerData={{ ...offerData }}
            docs={docs}
            saveValues={this.handleSaveValues}
            saveDocs={this.handleSaveDocs}
            uploadDoc={this.handleUpload}
            deleteDoc={this.handleDelete}
            cancel={this.handleCancel}
            config={root.saleConfig}
          />
        )}
        {ui.currentPanel === 'salePreview' && (
          <OfferPreview
            closePanel={() => ui.closePanel()}
            url={`/api/v1/sales/${root.saleId}/preview?locale=${root.user.claims.locale}`}
          />
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/SaleEditSection/index.jsx